/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CreateCardAccountRequestIdentityType = typeof CreateCardAccountRequestIdentityType[keyof typeof CreateCardAccountRequestIdentityType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCardAccountRequestIdentityType = {
  individual: 'individual',
  corporate: 'corporate',
} as const;
